import { render } from "./WaterRipple.vue?vue&type=template&id=a83bbc62&scoped=true"
import script from "./WaterRipple.vue?vue&type=script&lang=js"
export * from "./WaterRipple.vue?vue&type=script&lang=js"

import "./WaterRipple.vue?vue&type=style&index=0&id=a83bbc62&lang=scss&scoped=true"

import exportComponent from "E:\\developYZ\\yzWebsite\\newWebsite\\my-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a83bbc62"]])

export default __exports__